import { Box, Content, Heading } from "react-bulma-components";

import { useTranslation } from "react-i18next";

export const ResultsNoData = () => {
  const { t } = useTranslation();

  return (
    <Box style={{ textAlign: "center" }}>
      <Heading className="mb-1" size={5}>
        {t("results.nodata.title")}
      </Heading>

      <Content className="mb-2">{t("results.nodata.description")}</Content>
    </Box>
  );
};

export default ResultsNoData;
